/**
 * @generated SignedSource<<e317a40d2220ab339b8db78db861ba50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubLessonBlockModelTypeChoices = "ARCHIVED" | "BREAK" | "LESSON" | "%future added value";
export type PianofunclubLessonModelStatusChoices = "BLANK" | "BREAK" | "LEFT_SCHOOL" | "MISSED" | "NO_LESSON" | "OTHER_TEACHER" | "PRESENT" | "PRESENT_DOUBLE" | "PUPIL_ABSENT" | "STOPPED_LESSONS" | "TEACHER_ABSENT" | "%future added value";
export type PianofunclubLessonStageModelLessonTypeChoices = "GROUP" | "INDIVIDUAL" | "PAIRED" | "%future added value";
export type PianofunclubProfileModelStatusChoices = "ACTIVE" | "ARCHIVED" | "%future added value";
export type UpdateLessonBlockDetailsInput = {
  clientMutationId?: string | null | undefined;
  instrument?: string | null | undefined;
  keepFree?: boolean | null | undefined;
  lessonBlockIds: ReadonlyArray<string | null | undefined>;
  pupilId?: string | null | undefined;
  staffNoteForTeacher?: string | null | undefined;
  stageId?: string | null | undefined;
  teacherId?: string | null | undefined;
  teacherNoteForStaff?: string | null | undefined;
};
export type UpdateLessonBlockDetailsMutation$variables = {
  block: number;
  connections: ReadonlyArray<string>;
  input: UpdateLessonBlockDetailsInput;
  startingYear: number;
};
export type UpdateLessonBlockDetailsMutation$data = {
  readonly updateLessonBlockDetails: {
    readonly deletedLessonBlockIds: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly errors: any | null | undefined;
    readonly lessonBlocks: ReadonlyArray<{
      readonly enrolmentOffers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly archived: boolean;
            readonly id: string;
          } | null | undefined;
        } | null | undefined>;
      };
      readonly id: string;
      readonly instrument: {
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly keepFree: boolean;
      readonly lessonDay: number | null | undefined;
      readonly lessonStage: {
        readonly id: string;
        readonly lessonDuration: number | null | undefined;
        readonly lessonType: PianofunclubLessonStageModelLessonTypeChoices;
        readonly stage: number | null | undefined;
      } | null | undefined;
      readonly lessonTime: string | null | undefined;
      readonly lessons: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly lessonDuration: number | null | undefined;
            readonly rearrangedTimestamp: string | null | undefined;
            readonly replacementLessonColumnIndex: number | null | undefined;
            readonly scheduledTimestamp: string | null | undefined;
            readonly staffRegisterNoteForTeacher: string | null | undefined;
            readonly status: PianofunclubLessonModelStatusChoices;
            readonly teacherRegisterNoteForStaff: string | null | undefined;
            readonly weekWasRearranged: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined>;
      };
      readonly pupil: {
        readonly id: string;
        readonly primaryParent: {
          readonly id: string;
          readonly status: PianofunclubProfileModelStatusChoices;
        } | null | undefined;
        readonly schoolYear: number | null | undefined;
        readonly status: PianofunclubProfileModelStatusChoices;
        readonly user: {
          readonly firstName: string;
          readonly lastName: string;
        };
      } | null | undefined;
      readonly staffNoteForTeacher: string | null | undefined;
      readonly teacher: {
        readonly id: string;
        readonly totalLessons: number | null | undefined;
        readonly user: {
          readonly firstName: string;
          readonly lastName: string;
        };
      } | null | undefined;
      readonly teacherNoteForStaff: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly newPairedLessonBlocks: ReadonlyArray<{
      readonly id: string;
      readonly instrument: {
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly keepFree: boolean;
      readonly lessonDay: number | null | undefined;
      readonly lessonStage: {
        readonly id: string;
        readonly lessonDuration: number | null | undefined;
        readonly lessonType: PianofunclubLessonStageModelLessonTypeChoices;
        readonly stage: number | null | undefined;
      } | null | undefined;
      readonly lessonTime: string | null | undefined;
      readonly lessons: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly lessonDuration: number | null | undefined;
            readonly rearrangedTimestamp: string | null | undefined;
            readonly replacementLessonColumnIndex: number | null | undefined;
            readonly scheduledTimestamp: string | null | undefined;
            readonly staffRegisterNoteForTeacher: string | null | undefined;
            readonly status: PianofunclubLessonModelStatusChoices;
            readonly teacherRegisterNoteForStaff: string | null | undefined;
            readonly weekWasRearranged: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined>;
      };
      readonly pupil: {
        readonly id: string;
        readonly schoolYear: number | null | undefined;
        readonly user: {
          readonly firstName: string;
          readonly lastName: string;
        };
      } | null | undefined;
      readonly school: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly teacher: {
        readonly id: string;
        readonly user: {
          readonly firstName: string;
          readonly lastName: string;
        };
      } | null | undefined;
      readonly type: PianofunclubLessonBlockModelTypeChoices;
    } | null | undefined> | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type UpdateLessonBlockDetailsMutation = {
  response: UpdateLessonBlockDetailsMutation$data;
  variables: UpdateLessonBlockDetailsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "block"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startingYear"
},
v4 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedLessonBlockIds",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keepFree",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lessonDay",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lessonTime",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "staffNoteForTeacher",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teacherNoteForStaff",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schoolYear",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "DjangoUserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "ProfileNode",
  "kind": "LinkedField",
  "name": "primaryParent",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "block",
      "variableName": "block"
    },
    {
      "kind": "Variable",
      "name": "startingYear",
      "variableName": "startingYear"
    }
  ],
  "kind": "ScalarField",
  "name": "totalLessons",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "InstrumentNode",
  "kind": "LinkedField",
  "name": "instrument",
  "plural": false,
  "selections": [
    (v21/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lessonDuration",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonStageNode",
  "kind": "LinkedField",
  "name": "lessonStage",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stage",
      "storageKey": null
    },
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lessonType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonNodeConnection",
  "kind": "LinkedField",
  "name": "lessons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LessonNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scheduledTimestamp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rearrangedTimestamp",
              "storageKey": null
            },
            (v14/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "teacherRegisterNoteForStaff",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "staffRegisterNoteForTeacher",
              "storageKey": null
            },
            (v23/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weekWasRearranged",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "replacementLessonColumnIndex",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "EnrolmentOfferNodeConnection",
  "kind": "LinkedField",
  "name": "enrolmentOffers",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EnrolmentOfferNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EnrolmentOfferNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "archived",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "SchoolNode",
  "kind": "LinkedField",
  "name": "school",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "DjangoUserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v17/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "InstrumentNode",
  "kind": "LinkedField",
  "name": "instrument",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateLessonBlockDetailsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UpdateLessonBlockDetailsPayload",
        "kind": "LinkedField",
        "name": "updateLessonBlockDetails",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LessonBlockNode",
            "kind": "LinkedField",
            "name": "lessonBlocks",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "pupil",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "teacher",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v20/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LessonBlockNode",
            "kind": "LinkedField",
            "name": "newPairedLessonBlocks",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "pupil",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "teacher",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateLessonBlockDetailsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UpdateLessonBlockDetailsPayload",
        "kind": "LinkedField",
        "name": "updateLessonBlockDetails",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedLessonBlockIds",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LessonBlockNode",
            "kind": "LinkedField",
            "name": "lessonBlocks",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "pupil",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v29/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "teacher",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v20/*: any*/),
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              (v30/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LessonBlockNode",
            "kind": "LinkedField",
            "name": "newPairedLessonBlocks",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "pupil",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v15/*: any*/),
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "teacher",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              (v30/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d2ba6ac4fe52060bbae470b1017c1bc",
    "id": null,
    "metadata": {},
    "name": "UpdateLessonBlockDetailsMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateLessonBlockDetailsMutation(\n  $input: UpdateLessonBlockDetailsInput!\n  $startingYear: Int!\n  $block: Int!\n) {\n  updateLessonBlockDetails(input: $input) {\n    success\n    errors\n    deletedLessonBlockIds\n    lessonBlocks {\n      id\n      keepFree\n      lessonDay\n      lessonTime\n      staffNoteForTeacher\n      teacherNoteForStaff\n      pupil {\n        id\n        status\n        schoolYear\n        user {\n          firstName\n          lastName\n          id\n        }\n        primaryParent {\n          id\n          status\n        }\n      }\n      teacher {\n        id\n        totalLessons(startingYear: $startingYear, block: $block)\n        user {\n          firstName\n          lastName\n          id\n        }\n      }\n      instrument {\n        name\n        id\n      }\n      lessonStage {\n        id\n        stage\n        lessonDuration\n        lessonType\n      }\n      lessons {\n        edges {\n          node {\n            id\n            scheduledTimestamp\n            rearrangedTimestamp\n            status\n            teacherRegisterNoteForStaff\n            staffRegisterNoteForTeacher\n            lessonDuration\n            weekWasRearranged\n            replacementLessonColumnIndex\n          }\n        }\n      }\n      enrolmentOffers {\n        edges {\n          node {\n            id\n            archived\n          }\n        }\n      }\n    }\n    newPairedLessonBlocks {\n      id\n      keepFree\n      lessonDay\n      lessonTime\n      type\n      school {\n        id\n        name\n      }\n      pupil {\n        id\n        schoolYear\n        user {\n          firstName\n          lastName\n          id\n        }\n      }\n      teacher {\n        id\n        user {\n          firstName\n          lastName\n          id\n        }\n      }\n      instrument {\n        name\n        id\n      }\n      lessonStage {\n        id\n        stage\n        lessonDuration\n        lessonType\n      }\n      lessons {\n        edges {\n          node {\n            id\n            scheduledTimestamp\n            rearrangedTimestamp\n            status\n            teacherRegisterNoteForStaff\n            staffRegisterNoteForTeacher\n            lessonDuration\n            weekWasRearranged\n            replacementLessonColumnIndex\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f46fa990356ff40171fb35fb94d4c2dc";

export default node;
